module.exports = __webpack_public_path__ + "static/media/pastoral.d4d04cae.svg";